export function isGeshenType(type) {
  return type === 'geshen' || type === 'w_geshen'
}

/** 榜单/支付配置查找时，w_geshen 复用 geshen 配置 */
export function geshenLookupType(type) {
  return isGeshenType(type) ? 'geshen' : type
}

export function normalizeGeshenType(song) {
  if (!song) return
  if (song.type === 'w_geshen') {
    song.type = 'geshen'
  }
  if (song.muti_version) {
    song.muti_version.forEach((v) => {
      if (v.type === 'w_geshen') {
        v.type = 'geshen'
      }
    })
  }
}
